import ModelosVendasCupomService from "@/services/ModelosVendasCupomService";

export const modelosVendasCupom = {
  namespaced: true,
  state: {
    modelosVendasCupom: {},
  },
  actions: {
    getModelosVendasCupom({ commit }, payload) {
      return ModelosVendasCupomService.GetModelosVendasCupom(payload).then(
        (modelosVendasCupom) => {
          return Promise.resolve(modelosVendasCupom);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postModelosVendasCupom({ commit }, payload) {
      return ModelosVendasCupomService.PostModelosVendasCupom(payload).then(
        (modelosVendasCupom) => {
          return Promise.resolve(modelosVendasCupom);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putModelosVendasCupom({ commit }, payload) {
      return ModelosVendasCupomService.PutModelosVendasCupom(payload).then(
        (modelosVendasCupom) => {
          return Promise.resolve(modelosVendasCupom);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteModelosVendasCupom({ commit }, payload) {
      return ModelosVendasCupomService.DeleteModelosVendasCupom(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getModelosVendasCupomOData({ commit }, payload) {
      return ModelosVendasCupomService.GetModelosVendasCupomOData(payload).then(
        (modelosVendasCupom) => {
          return Promise.resolve(modelosVendasCupom);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default modelosVendasCupom;
